import { createElement } from 'rax';
import EmbedMonthPicker from '../embed-picker/month-picker';
import BaseRangePicker from './base-range-picker';
import { withLocale } from '../../locale';
class MonthRangePicker extends BaseRangePicker {
    get rangeType() {
        return 'month';
    }
    renderFirstChild(value, validRange, onChange) {
        return this.renderBase(value, validRange, onChange);
    }
    renderSecondChild(value, validRange, onChange) {
        return this.renderBase(value, validRange, onChange);
    }
    renderBase(value, validRange, onChange) {
        return <EmbedMonthPicker value={value} validRange={validRange} onChange={onChange}/>;
    }
    get format() {
        return this.props.format || 'YYYY-MM';
    }
}
export default withLocale(MonthRangePicker, {
    name: 'MonthRangePicker',
    defaultLocale: {
        ok: '',
        cancel: '',
        prev: '上一步',
        next: '下一步',
        selectStartTime: '选择开始日期',
        selectEndTime: '选择结束日期',
    },
});
